<app-page-breadcrumb pageTitle="Paquetes de Productos"></app-page-breadcrumb>

<div class="space-y-4">
  <!-- Controls -->
  <div class="flex items-center justify-between gap-2 flex-wrap">
    <div class="flex items-center gap-1.5"></div>
    <div class="flex items-center gap-1.5">
      <button
        type="button"
        (click)="toggleFilters()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 flex items-center gap-1.5"
      >
        <svg
          class="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
          ></path>
        </svg>
        {{ showFilters ? 'Ocultar' : 'Filtros' }}
      </button>
      <button
        type="button"
        (click)="nuevoBundle()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1.5"
      >
        <svg
          class="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 4v16m8-8H4"
          ></path>
        </svg>
        Nuevo Paquete
      </button>
    </div>
  </div>

  <!-- Filters Panel -->
  @if (showFilters) {
    <div
      class="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg p-3"
    >
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
            >Buscar por nombre</label
          >
          <input
            type="text"
            [(ngModel)]="filtroNombre"
            (ngModelChange)="buscar()"
            placeholder="Nombre del paquete..."
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          />
        </div>
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
            >Buscar por SKU</label
          >
          <input
            type="text"
            [(ngModel)]="filtroSku"
            (ngModelChange)="buscar()"
            placeholder="SKU del paquete..."
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          />
        </div>
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
            >Estado</label
          >
          <select
            [(ngModel)]="filtroIsActive"
            (ngModelChange)="buscar()"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          >
            <option [ngValue]="undefined">Todos</option>
            <option [ngValue]="true">Activos</option>
            <option [ngValue]="false">Inactivos</option>
          </select>
        </div>
        <div class="flex items-end">
          <button
            type="button"
            (click)="limpiarFiltro()"
            class="w-full px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700"
          >
            Limpiar Filtros
          </button>
        </div>
      </div>
    </div>
  }

  <!-- Loading -->
  @if (loading) {
    <div class="flex justify-center items-center py-12">
      <div
        class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"
      ></div>
      <span class="ml-3 text-gray-500 dark:text-gray-400"
        >Cargando paquetes...</span
      >
    </div>
  }

  <!-- Error -->
  @if (error) {
    <div
      class="p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20"
    >
      <div class="flex items-center gap-3">
        <svg
          class="w-5 h-5 text-error-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          ></path>
        </svg>
        <p class="text-error-600 dark:text-error-400">{{ error }}</p>
      </div>
    </div>
  }

  <!-- Tabla -->
  @if (!loading && !error) {
    <div
      class="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]"
    >
      <div class="max-w-full overflow-x-auto custom-scrollbar">
        <table class="min-w-full">
          <thead class="border-b border-gray-100 dark:border-white/[0.05]">
            <tr>
              <th
                class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
              >
                Nombre
              </th>
              <th
                class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
              >
                SKU
              </th>
              <th
                class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
              >
                Precio Paquete
              </th>
              <th
                class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
              >
                Descuento
              </th>
              <th
                class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
              >
                Estado
              </th>
              <th
                class="px-5 py-3 font-medium text-gray-500 text-center text-theme-xs dark:text-gray-400"
              >
                Acciones
              </th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-white/[0.05]">
            @if (bundles.length === 0) {
              <tr>
                <td
                  colspan="6"
                  class="px-5 py-8 text-center"
                >
                  <div
                    class="flex flex-col items-center gap-2 text-gray-500 dark:text-gray-400"
                  >
                    <svg
                      class="w-12 h-12"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1"
                        d="M20 7l-.867 12.142A2 2 0 0117.138 21H6.862a2 2 0 01-1.995-1.858L4 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                      ></path>
                    </svg>
                    <span>No hay paquetes registrados</span>
                  </div>
                </td>
              </tr>
            }

            @for (bundle of bundles; track bundle.id) {
              <tr [class.opacity-60]="!bundle.isActive">
                <td
                  class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400"
                >
                  <span
                    class="block font-medium text-gray-800 dark:text-white/90"
                    >{{ bundle.name }}</span
                  >
                  @if (bundle.description) {
                    <span
                      class="block text-xs text-gray-500 dark:text-gray-400 truncate max-w-xs"
                      >{{ bundle.description }}</span
                    >
                  }
                </td>
                <td
                  class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400"
                >
                  <span
                    class="font-mono text-xs text-gray-600 dark:text-gray-300"
                    >{{ bundle.sku }}</span
                  >
                </td>
                <td
                  class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400"
                >
                  @if (tienePromoActiva(bundle)) {
                    <span
                      class="block font-semibold text-gray-800 dark:text-white/90"
                    >
                      {{
                        formatPrecio(
                          bundle.promoPrice,
                          getCurrencyCode(bundle.currencyId)
                        )
                      }}
                    </span>
                  }
                  <span
                    class="font-semibold text-gray-800 dark:text-white/90"
                    [class.line-through]="tienePromoActiva(bundle)"
                    [class.text-xs]="tienePromoActiva(bundle)"
                  >
                    {{
                      formatPrecio(
                        bundle.bundlePrice,
                        getCurrencyCode(bundle.currencyId)
                      )
                    }}
                  </span>
                  @if (bundle.priceStrategy === 'sum_of_components') {
                    <span
                      class="block text-[10px] text-brand-500 dark:text-brand-400 font-medium"
                      >Suma de componentes</span
                    >
                  }
                </td>
                <td
                  class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400"
                >
                  @if (bundle.discountPercent && bundle.discountPercent > 0) {
                    <span
                      class="text-success-600 dark:text-success-400 font-medium"
                      >{{ bundle.discountPercent }}%</span
                    >
                  } @else {
                    <span class="text-gray-400">-</span>
                  }
                </td>
                <td
                  class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400"
                >
                  <app-badge [color]="getActiveColor(bundle)">{{
                    getActiveLabel(bundle)
                  }}</app-badge>
                </td>
                <td
                  class="px-4 py-3 text-gray-500 text-center text-theme-sm dark:text-gray-400"
                >
                  <div class="flex items-center justify-center gap-2">
                    <button
                      (click)="verDetalle(bundle)"
                      class="rounded-lg p-2 hover:bg-brand-50 hover:text-brand-600 dark:hover:bg-brand-900/20 dark:hover:text-brand-400 transition-colors"
                      title="Ver detalle"
                    >
                      <svg
                        class="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        ></path>
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                        ></path>
                      </svg>
                    </button>
                    <button
                      (click)="editarBundle(bundle)"
                      class="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-white/[0.05] transition-colors"
                      title="Editar"
                    >
                      <svg
                        class="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                        ></path>
                      </svg>
                    </button>
                    <button
                      (click)="eliminarBundle(bundle)"
                      class="rounded-lg p-2 hover:bg-error-50 hover:text-error-600 transition-colors"
                      title="Eliminar"
                    >
                      <svg
                        class="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                        ></path>
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <!-- Paginación -->
      @if (globalTotalPages >= 1) {
        <div
          class="mt-4 border-t border-gray-200 dark:border-gray-700 pt-4 px-5 pb-4"
        >
          <div class="flex items-center justify-between gap-4 flex-wrap">
            <div class="flex items-center gap-2">
              <span class="text-sm text-gray-500 dark:text-gray-400"
                >{{ globalTotalElements }} registros</span
              >
              <select
                [ngModel]="pageSize"
                (ngModelChange)="changePageSize($event)"
                class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
              >
                @for (opt of PAGE_SIZE_OPTIONS; track opt) {
                  <option [value]="opt">{{ opt }}</option>
                }
              </select>
            </div>
            <div class="flex items-center gap-2">
              <button
                type="button"
                (click)="cambiarPagina(globalPage - 1)"
                [disabled]="!hasPrevPage"
                class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
              >
                Anterior
              </button>
              <div class="flex items-center gap-1.5">
                <span class="text-sm text-gray-500 dark:text-gray-400"
                  >Página</span
                >
                <select
                  [ngModel]="pageDisplay"
                  (ngModelChange)="cambiarPagina($event - 1)"
                  class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
                >
                  @for (p of pagesArray; track p) {
                    <option [value]="p">{{ p }}</option>
                  }
                </select>
                <span class="text-sm text-gray-500 dark:text-gray-400"
                  >de {{ globalTotalPages }}</span
                >
              </div>
              <button
                type="button"
                (click)="cambiarPagina(globalPage + 1)"
                [disabled]="!hasNextPage"
                class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
              >
                Siguiente
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>

<!-- Detail modal -->
<app-product-bundle-detail-modal
  [isOpen]="showDetailModal"
  [bundle]="selectedBundle"
  (close)="cerrarModal()"
>
</app-product-bundle-detail-modal>
